<template>
  <div class="gis-popup">
    <div class="gis-popup-header">{{ item.layerName }}</div>
    <table v-if="list.length">
      <tbody>
        <tr v-for="item in list" :key="item.name">
          <td>{{ item.name }}</td>
          <td style="position: relative">
            {{ item.value }}
            <el-button
              style="
                position: absolute;
                top: 0;
                right: 0;
                font-size: 12px;
                padding: 5px;
              "
              icon="el-icon-aim"
              id="button"
              size="small"
              v-if="item.value === '水表箱'"
            >
            </el-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { Button } from "element-ui";

export default {
  components: {
    ElButton: Button,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    list() {
      let attributes = this.item?.attributes;
      let arr = [];
      if (this.item.geometryType === "esriGeometryPoint") {
        var 管理单位 = (attributes.管理单位 || "").replace("管线部", "营业所");

        if (attributes?.类型 === "水表箱") {
          return [
            { name: "类型", value: attributes.类型 },
            {
              name: "地址",
              value: attributes.安装地址.replace("湖北省武汉市江夏区", ""),
            },
            { name: "抄表员", value: " " },
            { name: "抄表单位", value: 管理单位 },
          ];
        }

        if (
          attributes?.类型 &&
          (attributes?.类型.includes("户表") || attributes?.类型 === "水表")
        ) {
          return [
            { name: "类型", value: attributes.类型 },
            { name: "口径", value: attributes.口径 },
            {
              name: "地址",
              value: attributes.安装地址.replace("湖北省武汉市江夏区", ""),
            },
            {
              name: "抄表员",
              value: attributes?.类型 === "私户表" ? "范倩雯" : "",
            },
            { name: "抄表单位", value: 管理单位 },
          ];
        }
      }
      if (attributes.安装地址) {
        attributes.安装地址 = attributes.安装地址.replace(
          "湖北省武汉市江夏区",
          ""
        );
      }
      if (attributes.管理单位) {
        attributes.管理单位 = attributes.管理单位.replace(
          "纸坊管线部",
          "建设管理部"
        );
      }
      if (attributes.埋深) {
        attributes.埋深 = attributes.埋深.replace(/^\./, "0.");
      }
      if (attributes.起点埋深) {
        attributes.起点埋深 = attributes.起点埋深.replace(/^\./, "0.");
      }
      for (let i in attributes) {
        if (attributes[i] !== "Null" && attributes[i] !== "") {
          arr.push({ name: i, value: attributes[i] });
        }
      }
      return arr;
    },
  },
  mounted() {
    this.$nextTick(() => {
      const button = document.getElementById("button");
      if (button) {
        document.addEventListener("click", this.handleClick);
      }
    });
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClick);
  },
  methods: {
    handleClick({ target }) {
      if (target.id === "button" || target.parentNode.id === "button") {
        this.$emit("detail");
      }
    },
  },
};
</script>

<style scoped lang="less">
.gis-popup {
  height: auto;
  padding-top: 20px;
  padding-bottom: 60px;
  font-size: 12px;

  table {
    border-collapse: collapse;
    border: 1px solid #fff;
    font-family: sans-serif;
    letter-spacing: 1px;
    width: 100%;
    overflow: hidden;
  }

  td {
    border: 1px solid #fff;
    padding: 2px 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  td:last-of-type {
    text-align: center;
  }
}
</style>
